module.exports = __webpack_public_path__ + "static/media/bursts_06.05a02d32.svg";